<template>
    <div>
      <Row>
        <Col span="23" offset="1" align="left" style="font-size: 17px">
          关于我们
          <hr>
        </Col>
        <Col span="23" offset="1"  align="left" >
          金宝会的理财项目均为经过严格线下审核的借款项目，由国有融资性担保公司等第三方增信机构提供全额担保。若借款人逾期还款，增信机构将对投资人进行代偿。
        </Col>
      </Row>
      <Row>
        <Col span="23" offset="1" align="left" style="font-size: 17px">
          介绍
          <hr>
        </Col>
        <Col span="23" offset="1"  align="left" >
          金宝会的理财项目均为经过严格线下审核的借款项目，由国有融资性担保公司等第三方增信机构提供全额担保。若借款人逾期还款，增信机构将对投资人进行代偿。
        </Col>
      </Row>
      <Row>
        <Col span="23" offset="1" align="left" style="font-size:17px">
        席位
          <hr>
        </Col>
        <Col span="23" offset="1"  align="left" >
          金宝会的理财项目均为经过严格线下审核的借款项目，由国有融资性担保公司等第三方增信机构提供全额担保。若借款人逾期还款，增信机构将对投资人进行代偿。
        </Col>
      </Row>
    </div>
</template>

<script>
    export default {
        name: "aboutUs"
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/other/components/aboutUs.vue